/*import { useAnimations, useGLTF, useScroll } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import { Group } from "three";

useGLTF.preload("/robot_playground.glb");

export default function Model() {
  // Use useRef without explicitly typing it
  const group = useRef(null); // no need to specify type `Group` here

  // Use useGLTF to load the model
  const { nodes, materials, animations, scene } = useGLTF("/robot_playground.glb");
  const { actions } = useAnimations(animations, scene);

  // Use useScroll to track scroll position
  const scroll = useScroll();

  useEffect(() => {
    // Initialize the animation and pause it at the beginning
    if (actions["Experiment"]) {
      actions["Experiment"].play().paused = true;
    }
  }, [actions]);

  useFrame(() => {
    // Update the animation in sync with the scroll position
    if (actions["Experiment"]) {
      actions["Experiment"].time = (actions["Experiment"].getClip().duration * scroll.offset) / 4;
    }
  });

  return (
    // Apply the ref correctly here
    <group ref={group}>
      <primitive object={scene} />
    </group>
  );
}*/

import { useAnimations, useGLTF } from "@react-three/drei";
import { useEffect, useRef, useState } from "react";
import * as THREE from 'three';  // Importa THREE para acceder a LoopRepeat

useGLTF.preload("/robot_playground.glb");

export default function Model({ containerSize }) {
  const group = useRef(null); // Referencia al grupo
  const [scale, setScale] = useState(1);
  // Carga el modelo
  const { nodes, materials, animations, scene } = useGLTF("/robot_playground.glb");
  const { actions } = useAnimations(animations, scene);

  useEffect(() => {
    // Inicia la animación en bucle infinito
    if (actions["Experiment"]) {
      actions["Experiment"]
        .play()  // Reproduce la animación
        .setLoop(THREE.LoopRepeat, Infinity)  // Establece el bucle infinito
        .paused = false;  // Asegúrate de que la animación no esté pausada
    }
  }, [actions]);


  /* useEffect(() => {
     // Ajustamos la escala del modelo para que ocupe el contenedor
     const scaleFactor = Math.min(containerSize.width, containerSize.height) / 600; // Ajusta el tamaño del modelo
     console.log("scale...",scaleFactor)
     setScale(scaleFactor);
 
     // Inicia la animación
     if (actions["Experiment"]) {
       actions["Experiment"].play().setLoop(THREE.LoopRepeat, Infinity).paused = false;
     }
   }, [containerSize, actions]);*/

  return (
    <group ref={group}
      scale={2}
      //scale={scale}
      position={[0, -1, 0]}>
      <primitive object={scene} />
    </group>
  );
}
